import { ActiveTicketTypeTab } from './types';

export const TABS = [
  { label: 'all', value: ActiveTicketTypeTab.All },
  { label: 'T.CashOut', value: ActiveTicketTypeTab.CashOut },
  { label: 'T.Live', value: ActiveTicketTypeTab.Live },
];
